type 대상고객 = "마켓봄" | "마켓봄도매";
type 기간단위 = "개월" | "주";
type 기간 = `${number}${기간단위}`;
type 무료체험기간 = Record<대상고객, 기간>;
export const 무료체험기간: 무료체험기간 = {
  마켓봄: "2주",
  마켓봄도매: "1개월",
};
